import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { productsSyncActions } from '../actions/products-sync.actions';
import {
    selectLastSyncLog,
    selectProductsSyncLoaded,
    selectProductsSyncLoading,
    selectProductsSyncPolling,
    selectProductsSyncSaved,
    selectProductsSyncSaving,
    selectSyncing,
} from '../selectors/products-sync.selector';

@Injectable({ providedIn: 'root' })
export class SyncFacade {
    private readonly store = inject(Store);

    readonly syncing = this.store.selectSignal(selectSyncing);
    readonly lastSyncLog = this.store.selectSignal(selectLastSyncLog);
    readonly loading = this.store.selectSignal(selectProductsSyncLoading);
    readonly loaded = this.store.selectSignal(selectProductsSyncLoaded);
    readonly saving = this.store.selectSignal(selectProductsSyncSaving);
    readonly saved = this.store.selectSignal(selectProductsSyncSaved);
    readonly polling = this.store.selectSignal(selectProductsSyncPolling);

    readonly syncing$ = this.store.select(selectSyncing);
    readonly lastSyncLog$ = this.store.select(selectLastSyncLog);
    readonly loading$ = this.store.select(selectProductsSyncLoading);
    readonly loaded$ = this.store.select(selectProductsSyncLoaded);
    readonly saving$ = this.store.select(selectProductsSyncSaving);
    readonly saved$ = this.store.select(selectProductsSyncSaved);
    readonly polling$ = this.store.select(selectProductsSyncPolling);

    selectSyncing$() {
        return this.syncing$;
    }

    selectLastSyncLog$() {
        return this.lastSyncLog$;
    }

    sync(): void {
        this.store.dispatch(productsSyncActions.syncItems());
    }

    checkSyncing(firstRun = false): void {
        if (firstRun) {
            this.store.dispatch(productsSyncActions.getSyncStatusQuiet());
        } else {
            this.store.dispatch(productsSyncActions.getSyncStatus());
        }
    }

    clear(): void {
        this.store.dispatch(productsSyncActions.clear());
    }
}
